import React from 'react'
import styled from 'styled-components'
import { STYLES } from '../../static/style'

const StyledBadge = styled.div`
  display: inline-block;
  font-size: ${STYLES.FONT_SIZE_SM};
  font-weight: ${STYLES.FONT_WEIGHT_NORMAL};
  color: ${STYLES.COLOR_WHITE};
  margin: ${STYLES.BADGE_MARGIN};
  overflow: hidden;
`

const BadgeContent = styled.div`
  display: flex;
  border-radius: ${STYLES.BORDER_RADIUS};
  overflow: hidden;
  line-height: ${STYLES.BADGE_LINE_HEIGHT};
`

const BadgeTitle = styled.div<{ bgColor?: string; textColor?: string }>`
  ${({ bgColor, textColor }) =>
    `
      background-color: ${bgColor || STYLES.COLOR_OUTER_SPACE_GRAY};
      color: ${textColor || STYLES.COLOR_WHITE};
    `};

  padding: ${STYLES.BADGE_CONTENT_PADDING};
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
`

const BadgeText = styled.div`
  background-color: ${({ bgColor }: { bgColor?: string }) =>
    bgColor ? bgColor : STYLES.COLOR_MERCURY_GRAY};
  color: ${STYLES.TEXT_COLOR};
  text-transform: capitalize;
  padding: ${STYLES.BADGE_CONTENT_PADDING};
`

interface IBadgeProps {
  className?: string
  title?: string
  titleTextColor?: string
  titleBackgroundColor?: string
  children: React.ReactNode | string
  textBackgroundColor?: string
  style?: React.CSSProperties
}

const Badge: React.FC<IBadgeProps> = ({
  title,
  titleTextColor,
  titleBackgroundColor,
  className,
  children,
  textBackgroundColor,
  style = {},
}) => {
  if (!children) {
    return null
  }
  return (
    <StyledBadge style={style} className={className}>
      <BadgeContent>
        {title && (
          <BadgeTitle textColor={titleTextColor} bgColor={titleBackgroundColor}>
            {title}
          </BadgeTitle>
        )}
        <BadgeText bgColor={textBackgroundColor}>
          {children.toLowerCase ? children.toLowerCase() : children}
        </BadgeText>
      </BadgeContent>
    </StyledBadge>
  )
}

export { Badge }
